import { AppRootState } from "@/shared/@types/app";
import { GetterTree } from "vuex";
import { IFrameBridgeState } from "../types";

export const getters: GetterTree<IFrameBridgeState, AppRootState> = {};
